import { cn } from '@/utils'

export const FileProgress = ({
	progress,
	small,
}: {
	progress: number
	small?: boolean
}) => {
	const width = small ? 48 : 60

	return (
		<div
			className={cn(
				'absolute inset-2 z-[1] flex flex-col items-center justify-center gap-1 rounded-full bg-light-blue text-blue',
				small ? 'type-body-caption' : 'type-body-medium',
			)}
		>
			{progress}%
			<div
				className="relative h-[10px] w-[60px] rounded-full bg-blue/20"
				style={{ width }}
			>
				<div
					className="absolute left-0 top-0 h-full rounded-full bg-blue transition-[width] duration-300 ease-out"
					style={{
						width: `${10 + ((width - 10) * progress) / 100}px`,
					}}
				/>
			</div>
		</div>
	)
}
